var SCM = SCM || {};

SCM.GiftAccessModals = (function ($) {
    return {
        init: init,
        openModalA: openModalA,
        openModalB: openModalB
    };

    function init() {
        wireEventHandlers();
        checkForPostSignInModalOpen();
    }

    function wireEventHandlers() {
        // Attach handlers directly to gift access buttons (may be in toolbar and/or content panel)
        $('.gift-article-access').on('click', handleGiftAccessButtonClick);

        // Attach handler for create gift link button in Modal B
        $('#giftAccessModalB').on('click', '.js-create-gift-link', handleCreateGiftLinkClick);
    }

    function handleGiftAccessButtonClick(e) {
        e.preventDefault();

        // Try to get authentication data from any gift access button that has it
        var $buttonWithData = $('.gift-article-access[data-is-user-logged-on]').first();
        var isUserLoggedOn = false;
        var isIndividualAccount = false;

        if ($buttonWithData.length > 0) {
            isUserLoggedOn = $buttonWithData.data('is-user-logged-on') === true || $buttonWithData.data('is-user-logged-on') === 'true';
            isIndividualAccount = $buttonWithData.data('is-individual-account') === true || $buttonWithData.data('is-individual-account') === 'true';
        }

        if (!isUserLoggedOn || !isIndividualAccount) {
            openModalA();
        } else {
            openModalB();
        }
    }

    function handleCreateGiftLinkClick(e) {
        e.preventDefault();
        // TODO: Implement gift link creation logic in future ticket
        // For now, just close the modal
        SCM.Modals.closeModal();
    }

    function checkForPostSignInModalOpen() {
        // Check sessionStorage flag set before sign-in redirect
        if (sessionStorage.getItem('openGiftAccessModalAfterSignIn') === 'true') {
            // Clear the flag immediately
            sessionStorage.removeItem('openGiftAccessModalAfterSignIn');

            // Verify user is logged in with personal account before opening Modal B
            var $buttonWithData = $('.gift-article-access[data-is-user-logged-on]').first();

            if ($buttonWithData.length > 0) {
                var isUserLoggedOn = $buttonWithData.data('is-user-logged-on') === true || $buttonWithData.data('is-user-logged-on') === 'true';
                var isIndividualAccount = $buttonWithData.data('is-individual-account') === true || $buttonWithData.data('is-individual-account') === 'true';

                if (isUserLoggedOn && isIndividualAccount) {
                    // Wait for page to fully load before opening modal
                    setTimeout(function() {
                        openModalB();
                    }, 500);
                }
            }
        }
    }

    function openModalA() {
        var $modalContent = $('#giftAccessModalA');

        // Set sessionStorage flag now - if Modal A opens, user will sign in
        sessionStorage.setItem('openGiftAccessModalAfterSignIn', 'true');

        // SCM.Modals handles all accessibility, focus management, and keyboard navigation automatically
        SCM.Modals.showModal($modalContent);
    }

    function openModalB() {
        var $modalContent = $('#giftAccessModalB');

        // TODO: Fetch actual gift articles remaining count from server
        // For now, use a placeholder value
        var giftArticlesRemaining = 10;
        $modalContent.find('.js-gift-articles-count').text(giftArticlesRemaining);

        // SCM.Modals handles all accessibility, focus management, and keyboard navigation automatically
        SCM.Modals.showModal($modalContent);
    }

})(jQuery);
